import { api, PartipostApiResponse } from './'
import { UploadType } from './uploads'
import { ContentData } from '../cloudinary'

export type S3ContentType = 'image' | 'video'

export interface UploadPartUrl {
    part_number: number
    url: string
}

export interface InitiateUploadRequest {
    // resource type, not the MIME type; becomes the first segment of the S3 key
    content_type: S3ContentType
    preset_type: UploadType
    // file extension without the dot, e.g. 'mp4', 'png'; becomes the key suffix
    file_format: string
    parts_count: number
}

export interface InitiateUploadResponse {
    key: string
    upload_id: string
    parts: UploadPartUrl[]
}

export interface CompletedPart {
    part_number: number
    etag: string
}

export interface CompleteUploadRequest {
    key: string
    upload_id: string
    parts: CompletedPart[]
}

export interface AbortUploadRequest {
    key: string
    upload_id: string
}

export const initiateUpload = (payload: InitiateUploadRequest) => {
    return api.post<PartipostApiResponse<InitiateUploadResponse>>('s3-uploads/initiate/', payload)
}

// returns the created PImage (PPMediaSerializer), same shape as the Cloudinary flow's ContentData
export const completeUpload = (payload: CompleteUploadRequest) => {
    return api.post<PartipostApiResponse<ContentData>>('s3-uploads/complete/', payload)
}

export const abortUpload = (payload: AbortUploadRequest) => {
    return api.post<PartipostApiResponse<Record<string, never>>>('s3-uploads/abort/', payload)
}
